import { makeKey } from '../../../../utils/reducerOperations';

export function updateShowModalState(state, payload) {
    return makeKey('popUpVisible',!state.popUpVisible);
}